import React, { useState, useEffect } from 'react';

const CoachNotesModal = ({ isOpen, onClose, athlete, onSaveNotes }) => {
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isOpen || !athlete) return;
    setLoading(true);
    
    // Fetch existing notes
    const fetchNotes = async () => {
      try {
        const API_URL = import.meta.env.VITE_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3000/api' : '/api');
        const res = await fetch(`${API_URL}/coach/clients/${athlete.id}/notes`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (res.ok) {
          const data = await res.json();
          setNotes(data.notes || '');
        }
      } catch (e) {
        console.error('Error fetching notes:', e);
      } finally {
        setLoading(false);
      }
    };
    
    fetchNotes();
  }, [isOpen, athlete]);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const API_URL = import.meta.env.VITE_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3000/api' : '/api');
      const res = await fetch(`${API_URL}/coach/clients/${athlete.id}/notes`, {
        method: 'PUT',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}` 
        },
        body: JSON.stringify({ notes })
      });
      if (!res.ok) throw new Error('Error al guardar las notas');
      
      if (onSaveNotes) onSaveNotes(notes);
      onClose();
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)', backdropFilter: 'blur(4px)',
      display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000,
      animation: 'fadeInTab 0.2s ease-out'
    }}>
      <div className="glass-panel" style={{ width: '90%', maxWidth: '600px', padding: '2rem', position: 'relative' }}>
        <button onClick={onClose} style={{
          position: 'absolute', top: '1rem', right: '1rem', background: 'transparent', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '1.5rem'
        }}>×</button>

        <h2 style={{ marginTop: 0, marginBottom: '0.5rem', color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          📝 Notas Privadas
        </h2>
        <p style={{ color: 'var(--health-cyan)', marginBottom: '1.5rem', fontSize: '0.9rem', fontWeight: 'bold' }}>
          Expediente de {athlete.name}
        </p>

        {loading ? (
          <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '2rem 0' }}>Cargando expediente...</p>
        ) : (
          <form onSubmit={handleSave}>
            <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
              Este bloc de notas es 100% privado y solo es visible para ti. El atleta no tiene acceso a esta información.
            </p>
            <textarea 
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Historial de lesiones, objetivos a largo plazo, recordatorios, preferencias..."
              style={{
                width: '100%', minHeight: '300px', padding: '1rem', borderRadius: '8px',
                background: 'rgba(0,0,0,0.3)', border: '1px solid var(--glass-border)',
                color: 'white', resize: 'vertical', fontFamily: 'inherit', marginBottom: '1.5rem',
                lineHeight: '1.5'
              }}
              autoFocus
            />
            
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
              <button type="button" onClick={onClose} style={{ background: 'transparent', color: 'white', border: '1px solid var(--glass-border)', padding: '0.6rem 1.2rem', borderRadius: '8px', cursor: 'pointer' }}>
                Cancelar
              </button>
              <button type="submit" disabled={saving} style={{ background: 'var(--health-cyan)', color: '#1a1a1a', border: 'none', padding: '0.6rem 1.5rem', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
                {saving ? 'Guardando...' : 'Guardar Expediente'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default CoachNotesModal;
